<template>
  <div class="flex max-w-1366 m-auto z-300 relative">
    <div class="absolute top-0 left-24 w-60 mr-48 bg-red-200" @click="back">
      <div
        class="fixed h-60 w-60 mr-48 cursor-pointer z-350 flex-shrink-0 rounded-50 shadow-back border flex items-center justify-center bg-white"
        @click="back"
      >
        <iCon class="h-32 w-32 text-main-0" :iconClass="'ico_System back'" type="svg"></iCon>
      </div>
    </div>
    <div class="py-24 px-52 pb-48 ml-120 bg-white rounded-12 shadow-bg z-300 mr-20 w-888 xl:w-1162">
      <h1 class="titleText text-left text-24 mb-10">
        {{ $t("__documentationPage._documentation") }}
      </h1>
      <div class="ml-40 mr-32 m-auto mt-20">
        <h1 class="titleText text-left text-14 mb-10">{{ $t("__documentationPage._manuals") }}</h1>
        <div class="mt-28" v-if="faqList.length">
          <div
            class="manualItem py-8 px-20 mb-12 flex justify-between items-center bg-grey-f7 rounded-10"
            v-for="e in faqList"
            v-bind:key="e"
          >
            <div>
              <div class="contentTitle text-left text-16">{{ e.name }}</div>
              <div class="text-left text-14 opacity-70">
                <span>{{ $t("__documentationPage._version") }} </span>{{ e.version }}
              </div>
            </div>
            <div class="flex justify-start items-center">
              <div class="mr-20">{{ e.time }}</div>
              <div
                class="mr-6 flex items-center justify-center cursor-pointer"
                @click="openWindow(e.link)"
              >
                <iCon class="h-24 w-24 text-main-0" :iconClass="'Ico_Preview'" type="svg"></iCon>
                <div class="previewText ml-12">{{ $t("__documentationPage._preview") }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Pagination
        class="mt-40"
        v-if="faqList.length"
        :totalPage="meta.total_page"
        :nowPage="meta.current"
        :range="range"
        @changePage="changePage"
        position="center"
      ></Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import { manual } from "@/api/manual.js";
import moment from "moment";

export default {
  name: "Documentation",
  components: {
    Pagination
  },
  data() {
    return {
      faqList: [],
      meta: {
        //Pagination data
        current: 1,
        total: 0,
        total_page: 0,
        page_size: 10
      }
    };
  },
  computed: {
    range() {
      return this.meta.total_page < 5 ? this.meta.total_page : 5;
    }
  },
  created() {},
  async mounted() {
    await this.getManual();
  },
  methods: {
    async getManual() {
      try {
        const sendData = {
          page_size: this.meta.page_size,
          page: this.meta.current
        };
        const { data } = await manual(sendData);
        console.log("Manuals", data);
        for (let i = 0; i < data.results.length; i++) {
          data.results[i]["time"] = moment(
            data.results[i].release_date.replace(/ /g, ""),
            moment.ISO_8601
          ).format("YYYY/MM/DD");
        }
        this.faqList = data.results;
        this.meta.total = data.count;
        this.meta.total_page = Math.ceil(data.count / this.meta.page_size);
        this.meta.current = data.current;
      } catch (error) {
        this.apiError = error.response.status;
      }
    },

    back() {
      this.$router.push({ path: "/" }).catch(err => err);
    },

    openWindow(link) {
      window.open(link);
    },

    async changePage(page) {
      this.meta.current = page;
      this.getManual();
    }
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
.manualItem {
  height: 88px;
}

.previewText {
  color: #006ce1;
}

.titleText {
  font-weight: bold;
}

.contentTitle {
  font-weight: 600;
}
</style>
